// Wizard Scope
// ------------
// - Wizard-Lightbox has the OPEN variable to control the default visibility after page load
//   e.g. Wizard-Step-2 should be open after page-load
document.addEventListener('alpine:init', () => {
    window.Alpine.data('wizard', (config) => ({
        open: config.open ?? false,
        modalName: config.modalName ?? '',
        successModal: config.successModal ?? '',
        errorModal: config.errorModal ?? '',
        urlParameterName: 'wizard',
        currentModalName: 'wizardModal',
        closeBackdrop: config.closeBackdrop ?? true,
        init() {
            // set wizardModalStatus to true by default
            this.$store.modalStore.wizardModalStatus = true;
            this.$store.modalStore.closeBackdrop = this.closeBackdrop;
            // check url parameter ?wizard=(...)
            const url = new URL(window.location.href);
            if(url.searchParams.has(this.urlParameterName) && String(url.searchParams.get(this.urlParameterName)) === 'true'
                    || parseInt(url.searchParams.get(this.urlParameterName)) === 1
            ) {
                this.$store.modalStore.openModal = true;
                this.$store.modalStore.currentModalName = this.currentModalName;
            }

            /* Open Wizard in Step 2 automatically and set overflow-hidden class to body tag */
            if(this.open) {
                this.$store.modalStore.openModal = true;
                this.$store.modalStore.currentModalName = this.currentModalName;
            }
        }
    }))
})
